/* global document */
import React from 'react'
import PropTypes from 'prop-types'
import { render } from 'react-dom'
import moment from 'moment'
import ReactDateTimePicker from 'react-widgets/lib/DateTimePicker'

import momentLocalizer from 'react-widgets-moment'

momentLocalizer(moment)

// import and track styles, mostly for frontend usage
import styles from '!style-loader/useable!css-loader!react-widgets/dist/css/react-widgets.css'

const TIME_FORMAT = 'h:mm a'
const DATE_FORMAT = 'M/D/YYYY'

const DatePicker = createPicker(
  'date-picker',
  date => new Date(date),
  date => moment(date).format(DATE_FORMAT),
  { time: false, format: DATE_FORMAT }
)

const TimePicker = createPicker(
  'time-picker',
  date => moment(date, 'HH:mm').toDate(),
  date => moment(date).format('HH:mm'),
  { calendar: false, time: true, format: TIME_FORMAT }
)

const DateTimePicker = createPicker(
  'datetime-picker',
  date => new Date(date.replace(/Z$/, '').replace('T', ' ')),
  date => moment(date).format('M/D/YYYY HH:mm'),
  { format: `${DATE_FORMAT} ${TIME_FORMAT}` }
)

export { DatePicker, TimePicker, DateTimePicker }

class EnhancedDateTimePicker extends React.Component {
  static propTypes = {
    time: PropTypes.bool,
    format: PropTypes.string.isRequired,
  }

  static defaultProps = {
    time: true,
  }

  constructor(props) {
    super(props)
    this.state = {
      time: props.time,
      format: props.format,
    }
  }

  enableTime = () => {
    this.setState({ time: true, format: `${DATE_FORMAT} ${TIME_FORMAT}` })
  }

  disableTime = () => {
    this.setState({ time: false, format: DATE_FORMAT })
  }

  render() {
    return <ReactDateTimePicker {...this.props} {...this.state} />
  }
}

/**
 * [createPicker description]
 * @param  {[type]} elementName
 * @param  {[type]} createDate
 * @param  {[type]} format
 * @param  {Object} [initialProps={}]
 * @return {[type]}
 */
function createPicker(elementName, createDate, format, initialProps = {}) {
  const containerKey = Symbol('containerKey')
  const hiddenKey = Symbol('hiddenKey')

  return class extends HTMLElement {
    createdCallback() {
      console.warn(`${elementName}#createdCallback`)
      styles.use()
    }

    detachedCallback() {
      console.warn(`${elementName}#detachedCallback`)
      this.removeChild(this[hiddenKey])
      this.removeChild(this[containerKey])
      styles.unuse()
    }

    attachedCallback() {
      console.warn(`${elementName}#attachedCallback`)

      const id = this.getAttribute('data-id')
      const name = this.getAttribute('data-name')
      const rawValue = this.getAttribute('value')

      this[hiddenKey] = createHiddenInput(id, name, rawValue)
      this.appendChild(this[hiddenKey])

      this[containerKey] = document.createElement('div')
      this.appendChild(this[containerKey])

      const props = {
        ...initialProps,
        onChange: date => {
          this[hiddenKey].setAttribute('value', date ? format(date) : null)
        },
      }

      // conver the existing value into a date object
      if (rawValue && rawValue !== '') {
        props.defaultValue = createDate(rawValue)
      }

      this.component = render(
        <EnhancedDateTimePicker {...props} />,
        this[containerKey]
      )
    }
  }
}

/**
 * [createHiddenInput description]
 * @param  {[type]} id
 * @param  {[type]} name
 * @param  {[type]} [value=null]
 * @return {[type]}
 */
function createHiddenInput(id, name, value = null) {
  const hidden = document.createElement('input')
  hidden.type = 'hidden'
  if (id) hidden.id = id
  if (name) hidden.name = name
  if (value) hidden.value = value
  return hidden
}



// WEBPACK FOOTER //
// ./src/elements/datetime/index.js